var _line, _line2, _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMutewhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    height: "50px",
    id: "Layer_1",
    viewBox: "0 0 50 50",
    width: "50px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    x1: 32,
    x2: 42,
    y1: 20,
    y2: 30
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    x1: 42,
    x2: 32,
    y1: 20,
    y2: 30
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 50,
    width: 50
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 50,
    width: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,33H3  c-1.103,0-2-0.898-2-2V19c0-1.102,0.897-2,2-2h7",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.604,32.43  C9.256,32.129,9,31.391,9,30.754V19.247c0-0.637,0.256-1.388,0.604-1.689L22.274,4.926C23.905,3.27,26,3.898,26,6.327v36.988  c0,2.614-1.896,3.604-3.785,1.686L9.604,32.43z",
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.9797
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutewhite);
export default __webpack_public_path__ + "static/media/mutewhite.099506f9782cbce5dcf707afc47e6792.svg";
export { ForwardRef as ReactComponent };